/* eslint-disable @typescript-eslint/no-explicit-any */
const useHorizontalBarLabel = () => {
  const getHorizontalBarLabel = (chart: any) => {
    const {
      ctx,
      chartArea: { left },
      data
    } = chart;

    data.datasets.forEach((label: string, datasetIndex: number) => {
      const meta = chart.getDatasetMeta(datasetIndex);
      meta.data.forEach((datapoint: any, index: number) => {
        ctx.font = '14px Noto Sans KR';
        ctx.fillStyle = '#000000';
        ctx.textAlign = 'left';
        ctx.fillText(data.labels[index], left, datapoint.y + 5);
      });
    });
  };

  return getHorizontalBarLabel;
};

export default useHorizontalBarLabel;
